import { VueModule } from '@Foundation';
import BigQuote from './code/Scripts/components/big-quote';

export default VueModule({
  components: {
    BigQuote
  }
});
